(() => {
  if (customElements.get('performance-size-chart')) return;

  customElements.define('performance-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (!window.Shopify?.designMode) return;

      this._onBlockSelect = (event) => {
        const targetRow = event.target instanceof Element
          ? event.target.closest('[data-performance-size-row-id]')
          : null;
        const row = targetRow && this.contains(targetRow)
          ? targetRow
          : Array.from(this.querySelectorAll('[data-performance-size-row-id]'))
            .find((candidate) => candidate.dataset.performanceSizeRowId === event.detail?.blockId);

        if (!row) return;

        const radio = Array.from(this.querySelectorAll('input[type="radio"]'))
          .find((input) => input.value === row.dataset.performanceSizeFit);
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const drawer = this.closest('x-drawer');
        if (typeof drawer?.show === 'function') {
          drawer.show(false);
        } else {
          drawer?.setAttribute('open', 'immediate');
        }
      };

      this._onSectionUnload = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId) {
          this.closest('x-drawer')?.remove();
        }
      };

      // Drawers move to document.body when opened, so section-local listeners cannot
      // reliably receive editor selection events for the measurement rows.
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      document.addEventListener('shopify:section:unload', this._onSectionUnload);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      document.removeEventListener('shopify:section:unload', this._onSectionUnload);
    }
  });
})();
